import styled from 'styled-components';
import { shimmer } from '../styles/animations';

const SkeletonTitle = styled.div`
  height: 1.25rem;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  width: 8rem;
  animation: ${shimmer} 0.8s ease-in-out infinite alternate;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
`;

export default SkeletonTitle;
